import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "system-info-card"
};
var _hoisted_2 = {
  class: "mb-5"
};
var _hoisted_3 = {
  class: "columns"
};
var _hoisted_4 = {
  class: "column is-6 is-3-fullhd"
};
var _hoisted_5 = {
  class: "has-text-weight-normal"
};
var _hoisted_6 = {
  key: 0,
  class: "column is-6 is-3-fullhd"
};
var _hoisted_7 = {
  class: "has-text-weight-normal"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_el_form = _resolveComponent("el-form");

  var _component_el_card = _resolveComponent("el-card");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
    class: "box-card"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("systeminfo.title")), 1), _createVNode(_component_el_form, {
        ref: "form",
        model: _ctx.ruleForm,
        "label-position": "top",
        "hide-required-asterisk": true
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form_item, {
            class: "has-text-weight-bold",
            prop: "appVersion",
            label: _ctx.$t('systeminfo.app-version')
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.ruleForm.appVersion), 1)];
            }),
            _: 1
          }, 8, ["label"])]), _ctx.ruleForm.windowsAppVersion ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_form_item, {
            class: "has-text-weight-bold",
            prop: "windowsAppVersion",
            label: _ctx.$t('systeminfo.desktop-app-version')
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.ruleForm.windowsAppVersion), 1)];
            }),
            _: 1
          }, 8, ["label"])])) : _createCommentVNode("", true)])];
        }),
        _: 1
      }, 8, ["model"])];
    }),
    _: 1
  })]);
}